import Auth from '../../../modules/Auth'
import Global from '../../../constants/Global'


export async function setImage({ commit }, { image }) {
  await commit('set_item_image', image)
}
export async function setImageByISBNLink({ commit }, { link }) {
  await commit('set_item_image_by_isbn', link)
}

export function getItemSearch({ commit }, query) {
  fetch(Global.getServerDomain() + `/item/search`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      query: query
    })
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      if (payload) {
        const searchResult = []
        let rowIndex = payload.length - 1
        payload.forEach(function (element) {
          const item = {}
          item.Item_id = element.id
          item.Title = element.title
          item.Picture = element.picture
          item.Description = element.description
          item.Type = element.type
          item.Category = element.category
          item.Condition = element.condition
          item.Cash = element.cash
          item.Points = element.points
          item._showDetails = false
          item.index = rowIndex
          rowIndex--
          searchResult.push(item)
        }, this)
        commit('search_items', searchResult)
      }
    })
    .catch(error => console.error('Error: ', error))
}

export function setImageOrientation({ commit }, imageOrientation) {
  commit('set_item_image_orientation', imageOrientation)
}

export function setImageFile({ commit }, { imageFile }) {
  commit('set_image_file', imageFile)
}

export function setNewItemTitle({ commit }, input) {
  commit('set_item_title', input)
}

export function setNewItemDescription({ commit }, input) {
  commit('set_item_description', input)
}

export function setNewItemAuthor({ commit }, input) {
  commit('set_item_author', input)
}

export function setNewItemSynopsis({ commit }, input) {
  commit('set_item_synopsis', input)
}

export function setNewItemIsbn({ commit }, input) {
  commit('set_item_isbn', input)
}

export function setNewItemIsbnImageLink({ commit }, input) {
  commit('set_item_isbn_image_link', input)
}

export function setNewItemType({ commit }, input) {
  commit('set_item_type', input)
}

export function setNewItemPaymentType({ commit }, input) {
  commit('set_item_payment_type', input)
}

export function setNewItemPaymentValues({ commit }, { input }) {
  commit('set_item_payment_values', input)
}

export function setNewItemCategory({ commit }, input) {
  commit('set_item_category', input)
}

export function setNewItemCondition({ commit }, input) {
  commit('set_item_condition', input)
}

export function setNewItemAvailableOnlyToGroups({ commit }, availableOnlyToGroups) {
  commit('set_item_my_groups', { availableOnlyToGroups: availableOnlyToGroups })
}

export async function fetchItemProfile({ commit }, id) {
  const result = await new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/item/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      }
    })
      .then(function (res) {
        resolve(res.json())
      })
      .catch(error => console.error(error))
  });
  commit('item_profile', result)
}

export async function postItem({ commit, dispatch }, input) {
  const fetchUrl = Global.getServerDomain() + '/item';
  const fetchType = 'POST';
  input.description = input.description.replace(/\n/g, "<br>");
  if (!input.payment_type.includes("points")) {
    input.points = 0;
  }
  if (!input.payment_type.includes("money")) {
    input.cash = 0;
  }
  let responseStatus = "";
  let result = await new Promise((resolve) => {
    fetch(fetchUrl, {
      method: fetchType,
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify(input)
    })
      .then(function (res) {
        responseStatus = res.status;
        resolve(res.json())
      })
      .catch(error => console.error('Error: ', error))
  })
  commit('post_item_response', result);
  if (responseStatus == 200 && input.image_file) dispatch('postItemImage', { itemId: result.itemId, imageFile: input.image_file })
}

export function resetNewItem({ commit }) {
  commit('reset_new_item')
}

export function resetItemImage({ commit }) {
  commit('reset_item_image')
}
export function resetItemISBNImage({ commit }) {
  commit('reset_item_isbn_image')
}

export function prepareUpdatedItem({ commit }, update) {
  commit('updated_item', update)
}

export async function updateItem({ commit, dispatch }, { item, item_id }) {
  item.description = item.description ? item.description.replace(/\n/g, "<br>") : "";
  if (!item.payment_type.includes("points")) {
    item.points = 0;
  }
  if (!item.payment_type.includes("money")) {
    item.cash = 0;
  }
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/item/` + item_id, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify(item)
    })
      .then(function (res) {
        resolve(res.json())
      })
      .catch(error => console.error(error))
  });
  if (item.image_file) {
    await dispatch('postItemImage', { itemId: item_id, imageFile: item.image_file })
  }
  commit('post_item_response', result);
  commit('update_item', result);
}

export function fetchUserInventory({ commit, dispatch }, query) {
  fetch(Global.getServerDomain() + `/profile/${query}/inventory`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(async function (payload) {
      if (payload) {
        const searchResult = []
        let rowIndex = payload.length - 1
        payload.forEach(function (element) {
          const item = {}
          item.id = element.id
          item.Item_id = element.id
          item.Title = element.title
          item.Picture = element.picture
          item.Description = element.description
          item.Type = element.type
          item.Category = element.category
          item.Condition = element.condition
          item.Cash = element.cash
          item.CreatedAt = element.createdAt
          item.Points = element.points
          item._showDetails = false
          item.isRequested = [undefined, undefined]
          item.countInterested = item.isRequested.length
          item.index = rowIndex
          rowIndex--
          searchResult.push(item)
        }, this)
        commit('user_inventory', searchResult)
        await dispatch('fetchItemRequestReceived')
        dispatch('userInvetoryMergeRequests', { user_inventory: payload })
      }
    })
    .catch(error => console.error(error))
}

export async function searchAPI({ commit }, { query }) {
  commit("search_query", query);
  commit("clear_search");
  const result = await new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/search?query=${query}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        resolve(res.json())
      })
      .catch(error => console.error(error))
  });
  commit("search_result", { result: result, query: query })
}

export async function searchAutocompleteAPI({ commit }, { query }) {
  const result = await new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/search/autocomplete?query=${query}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        resolve(res.json())
      })
      .catch(error => console.error(error))
  });
  commit("search_autocomplete", { result: result })
}

export async function fetchItemMessages({ commit }, id) {
  fetch(Global.getServerDomain() + `/messages/item/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  }).then(res => {
    return res.json()
  }).then(payload => {
    commit("item_messages", payload);
  }).catch(error => console.error(error))
}

export async function postItemMessage({ commit }, { id, text, user }) {
  fetch(Global.getServerDomain() + `/messages/item/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      msg: text
    })
  }).then(res => {
    return res.json()
  }).then(payload => {
    payload.sender = user;
    commit("item_post_messages", payload);
  }).catch(error => console.error(error))
}

export async function postItemImage(commit, { itemId, imageFile }) {
  let data = new FormData();
  data.append("image", imageFile);
  return await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/images/item/${itemId}`, {
      method: "POST",
      headers: {
        'auth_key': Auth.getToken()
      },
      body: data
    }).then(res => {
      resolve(res.json())
    }).catch(error => console.error(error))
  })
}

export async function makeItemRequest({ commit }, { itemId, paymentBy }) {
  let path = `/request/${itemId}`;
  if (paymentBy) {
    path += `?pay=${paymentBy}`;
  }
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
    }).then(res => {
      resolve(res.json())
    }).catch(error => console.error(error))
  })
  commit("post_item_response", result);
  return result;
}

export async function acceptItemRequest({ dispatch }, { request }) {
  let responseStatus = "";
  await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/request/accept/${request.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({ request: request })
    }).then(res => {
      responseStatus = res.status;
      resolve(res.json())
    }).catch(error => console.error(error))
  })
  if (responseStatus == 200) {
    await dispatch('fetchItemRequestMade');
    await dispatch('fetchUserInventory', localStorage.getItem("user_id"));
    await dispatch("setUnreadRequests", { requestIds: [request.id] });
  }
  return responseStatus;
}

export async function declineItemRequest({ dispatch }, { request }) {
  let responseStatus = ""
  await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/request/reject/${request.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({ request })
    }).then(res => {
      responseStatus = res.status;
      resolve(res.json())
    }).catch(error => console.error(error))
  })
  if (responseStatus == 200) {
    await dispatch('fetchItemRequestMade');
    await dispatch('fetchUserInventory', localStorage.getItem("user_id"));
    await dispatch("setUnreadRequests", { requestIds: [request.id] });
  }
  return responseStatus;
}

export async function fetchItemRequestMade({ commit }) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/request/made`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      }
    })
      .then(res => {
        resolve(res.json());
      }).catch(error => console.log("Error: ", error))
  });
  const arr = result.filter(req => {
    if(req.item && req.item !== undefined) return req;
  })
  commit('set_item_requests_made', arr);
  // commit('set_activity_notification')
}

export async function fetchItemRequestReceived({ commit }) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/request/received`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      }
    })
      .then(res => {
        resolve(res.json());
      }).catch(error => console.log("Error: ", error))
  });
  commit('set_item_requests_received', result);
}

export async function setItem({ dispatch }, { item }) {
  await dispatch('setImageFile', { imageFile: item.image_file });
  await dispatch('setNewItemTitle', item.title);
  await dispatch('setNewItemDescription', item.description);
  await dispatch('setNewItemAuthor', item.author);
  await dispatch('setNewItemSynopsis', item.synopsis);
  await dispatch('setNewItemType', item.type);
  let payload = {
    points: item.points,
    cash: item.cash,
  };
  await dispatch('setNewItemCategory', item.category);
  await dispatch('setNewItemCondition', item.condition);
  await dispatch('setImage', { image: item.image })
  await dispatch('setNewItemPaymentType', item.payment_type);
  await dispatch('setNewItemPaymentValues', { input: payload });
}

export async function fetchImageItem(commit, { item_id }) {
  return await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/image/item/${item_id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      }
    })
      .then(res => {
        resolve(res.json());
      }).catch(error => console.log("Error: ", error))
  });
}

export async function setNewItemGroups({ commit }, { groups, groupsId }) {
  commit('set_new_item_groups', { groups: groups, groupsId: groupsId });
}

export function setNewItemStep({ commit }, { step }) {
  commit('set_new_item_step', { step: step })
}

export function removeNewItemAtGroup({ commit }, { index }) {
  commit('remove_new_item_at_group', { index: index })
}
export function userInvetoryMergeRequests({ commit }, { user_inventory }) {
  commit('set_inventory_requests', { inventory: user_inventory });
}
export function setItemInterested({ commit }, { item, requestId }) {
  commit('set_interested', { item: { ...item, requestId: requestId } })
}
export async function setActivitiyNotifications({ commit }) {
  await commit('set_activity_notification')
}
export function mergeRequestsReceivedMade({ commit }) {
  commit('merge_requests_received_made');
}

export async function updateItemStatus({ commit }, {item}) {
  return await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/item/${item.id}/status`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({status: item.status})
    }).then(res => {
      commit('update_item_status', {item: item})
      resolve(res.json())
    }).catch(error => console.error(error))
  })
}

export async function setReadRequests(parsers, { requestIds }) {
  return await new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/request/seen`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        requestIds,
        status: 1,
      })
    }).then(function (res) {
      resolve(res.json());
    })
      .catch(error => console.error(error));
  })
}

export async function setReadSent(parsers, { requestIds }) {
  return await new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/request/sentSeen`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        requestIds,
        status: 1,
      })
    }).then(function (res) {
      resolve(res.json());
    })
      .catch(error => console.error(error));
  })
}

export async function setReadReceived(parsers, { requestIds }) {
  return await new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/request/receivedSeen`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        requestIds,
        status: 1,
      })
    }).then(function (res) {
      resolve(res.json());
    })
      .catch(error => console.error(error));
  })
}

export async function setUnreadRequests(parsers, { requestIds }) {
  return await new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/request/seen`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        requestIds,
        status: 0,
      })
    }).then(function (res) {
      resolve(res.json());
    })
      .catch(error => console.error(error));
  })
}

export async function deleteItem({ dispatch }, itemId) {
  return await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/item/${itemId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      }
    })
      .then(function (res) {
        resolve(res.json())
        dispatch('fetchFeed')
      })
      .catch(error => console.error(error))
  });
}

export async function fetchRandomItems({ commit }) {
  const result = await new Promise((resolve) => {
    fetch(Global.getServerDomain() + '/search/random', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        resolve(res.json())
      })
      .catch(error => console.error(error))
  });
  commit("random_items", { result: result });
}

export function setFetchingActivityPage({ commit }, value) {
  commit("is_fetching_activity_page", value);
}


export async function getItemStatus(commit , itemId) {
  return await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/item/${itemId}/status`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      }
    })
      .then(res => {
        resolve(res.json());
      }).catch(error => console.log("Error: ", error))
  });

}
